window.hoculus = window.hoculus || {};
if (console && console.log) {
	console.log(
		"Coded by %cHoculus srl %con %cShopify %c- %c" +
			Shopify.theme.name +
			" %c -> https://www.hoculus.com",
		"color: red; font-weight: bold",
		"color: unset",
		"color: green",
		"color: unset",
		"color: blue",
		"color: unset; font-weight: bold"
	);
}
hoculus.utils = {
	addDiscount: function (discount) {
		return new Promise(function (resolve, reject) {
			$.ajax({
				url: "/discount/" + discount,
				complete: function (data) {
					resolve(data);
				},
			});
		});
	},
	addToCart: function (items) {
		return new Promise(function (resolve, reject) {
			var postData = {
				items: items,
			};
			$.ajax({
				url: "/cart/add.js",
				dataType: "json",
				cache: false,
				type: "post",
				data: postData,
				beforeSend: function () {
				},
				success: function (itemData) {
					// console.log(itemData)
				},
				error: function (XMLHttpRequest) {
					// var response = eval("(" + XMLHttpRequest.responseText + ")");
					// console.log(response.error, response = response.description)
				},
				complete: function (data) {
					resolve(data);
				},
			});
		});
	},
	onLoad: function () {
		setTimeout(function () {
			hoculus.singleCartCrossell();
			hoculus.radioBundle.init();
		}, 2);
	},
};
hoculus.domready = function (callback) {
	if (document.readyState == "complete") callback();
	else document.addEventListener("DOMContentLoaded", callback());
};
hoculus.domready(function () {
	hoculus.utils.onLoad();
});
hoculus.singleCartCrossell = function(){
	const sections = document.querySelectorAll('.hoculus-cart-single-crossell');
	const forms = document.querySelectorAll('.hoculus-cart-single-crossell form');
	forms.forEach(function(e,i){
		e.addEventListener('submit',function(f){
			// console.log(f);
			hoculus.utils.addDiscount(sections[i].dataset.hoculusDiscount).then(resp => sections[i].closest('div[id^="shopify-section"]').remove());
		})
	})
}
hoculus.radioBundle = {
	selectors: {
		parent: ".hoculus-bundle-custom-radio-group",
		radio:".hoculus-bundle-radio-container input[type=radio]" 
	},
	init: function(){
		hoculus.radioBundle.parents = document.querySelectorAll(hoculus.radioBundle.selectors.parent);
		if(hoculus.radioBundle.parents.length > 0){
			hoculus.radioBundle.submitButton = document.querySelector('#'+hoculus.radioBundle.parents[0].dataset.hoculusBundleFormId+' button[type="submit"]');
			hoculus.radioBundle.onSubmitBinded = hoculus.radioBundle.onSubmit.bind(event);
			hoculus.radioBundle.submitButton.addEventListener("click",hoculus.radioBundle.onSubmitBinded);
			document.querySelectorAll(hoculus.radioBundle.selectors.radio).forEach(e => {
				new hoculus.radioBundle.radioOption(e);
			})
			hoculus.radioBundle.getSelectedVariants();
		}
	},
	getSelectedVariants: function(){
		hoculus.radioBundle.selectedVariants = [];
		hoculus.radioBundle.attributes = [];
		document.querySelectorAll('[data-hoculus-custom-bundle-attribute]').forEach(e => e.remove());
		document.querySelectorAll('[data-hoculus-bundle-attribute]').forEach(e => {e.style.display = 'none';})
		document.querySelectorAll(hoculus.radioBundle.selectors.radio+':checked').forEach(e => {
			if(e.dataset.variantId){
				var item = {
					'id': parseInt(e.dataset.variantId),
					'qty': 1
				}
				var parentProductId = e.closest('[data-product-id]').dataset.productId;
				var attributeInputs = document.querySelectorAll('[data-hoculus-bundle-attribute][data-product-id="'+parentProductId+'"]');
				attributeInputs.forEach(e => {
					e.style.display = 'block';
					if(e.value != ''){
						item.properties = {}; 
						item.properties[e.dataset.hoculusBundleAttribute] = e.value;
					}
				})
				hoculus.radioBundle.selectedVariants.push(item);
				if(e.dataset.mainProductAttributeName){
					var attribute = {
						'name': e.dataset.mainProductAttributeName,
						'value': e.dataset.mainProductAttributeValue
					}
					hoculus.radioBundle.attributes.push(attribute);
				}
			}
		})
		hoculus.radioBundle.attributes.forEach(e => {hoculus.radioBundle.addAttribute(e)});
	},
	addAttribute: function(item){
		var attribute = document.createElement('input');
		attribute.type = 'hidden';
		attribute.dataset.hoculusCustomBundleAttribute = '';
		attribute.name='properties['+item.name+']';
		attribute.value=item.value;
		document.querySelector('#'+hoculus.radioBundle.parents[0].dataset.hoculusBundleFormId).appendChild(attribute);
	},
	onSubmit:async function(){
		hoculus.radioBundle.getSelectedVariants();
		if(hoculus.radioBundle.selectedVariants.length > 0){
			hoculus.radioBundle.submitButton.removeEventListener("click",hoculus.radioBundle.onSubmitBinded);
			this.event.preventDefault();
			await hoculus.utils.addToCart(hoculus.radioBundle.selectedVariants);
			window.setTimeout(function(){
				hoculus.radioBundle.submitButton.click();
				window.setTimeout(function(){
					hoculus.radioBundle.onSubmitBinded = hoculus.radioBundle.onSubmit.bind(event);
					hoculus.radioBundle.submitButton.addEventListener("click",hoculus.radioBundle.onSubmitBinded);
				},100)
			},100)
		}
	},
	radioOption: class{
		constructor(el){
		  var _this = this;
		  this.checkboxEl = el;
		  this.checkboxEl.addEventListener('change',_this.onChange.bind(_this))
		}
		onChange(){
			hoculus.radioBundle.getSelectedVariants();
		}
	}
}